import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddStudentMutation,useGetManagerListQuery} from "../../Services/api";

export default function AddStudent() {
    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("first name fields is required"),
        last_name: Yup.string().required("last name fields is required"),
        mobile_number: Yup.string().required("phone number fields is required"),
        email: Yup.string().required("email fields is required"),
        dob: Yup.string().required("date of birth fields is required"),
        mail_address: Yup.string().required("mail address fields is required"),
        referred_by: Yup.string().required("referred by fields is required"),
        addition_email: Yup.string().required("addition email fields is required"),
        allocate_trainer: Yup.string().required("allocate trainer fields is required"),
    });
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [addStudent,isLoading] = useAddStudentMutation();
    const onSubmit = (values,e) => {
        
            addStudent({ data: values })
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    e.target.reset()
                    toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                
                }
            })
            .catch((error) => {
                
                toast.error(error.data.message)
            });
            notify();
    };
    const { 
        data: ManagerList        
    } = useGetManagerListQuery();
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Learners</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">first name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("first_name")} className="form-control" />
                                <span className="text-danger">{errors.first_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">last name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("last_name")} className="form-control" />
                                <span className="text-danger">{errors.last_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mobile number</label>
                            <div className="col-sm-10">
                                <input type="number" {...register("mobile_number")} className="form-control" />
                                <span className="text-danger">{errors.mobile_number?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">email</label>
                            <div className="col-sm-10">
                                <input type="email" {...register("email")} className="form-control" />
                                <span className="text-danger">{errors.email?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">date fo birth</label>
                            <div className="col-sm-10">
                                <input type="date" {...register("dob")} className="form-control" />
                                <span className="text-danger">{errors.dob?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">mail address</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("mail_address")} className="form-control" />
                                <span className="text-danger">{errors.mail_address?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Select referred by</label>
                            <div className="col-sm-10">
                                <select  {...register("referred_by")} className="form-control" >
                                 <option value="">Select referred by</option>                                           

                                {                            
                                ManagerList?.data?.map((item) => {
                                    return (
                                        <option key={item.teacher_id} value={item.teacher_id}>{item.name}</option>                                           
                                        )
                                    })
                                } 
                                </select>
                                <span className="text-danger">{errors.referred_by?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">addition email</label>
                            <div className="col-sm-10">
                                <input type="email" {...register("addition_email")} className="form-control" />
                                <span className="text-danger">{errors.addition_email?.message}</span>
                            </div>
                        </div>  
                        <div className="row mb-3">
                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Select allocate trainer</label>
                            <div className="col-sm-10">
                                <select  {...register("allocate_trainer")} className="form-control" >
                                <option value="">Select allocate trainer</option> 
                                {                            
                                ManagerList?.data?.map((item) => {
                                    return (
                                        <option key={item.teacher_id} value={item.teacher_id}>{item.name}</option>                                           
                                        )
                                    })
                                }
                                </select>   
                                <span className="text-danger">{errors.allocate_trainer?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Select gender</label>
                            <div className="col-sm-10">
                                <select  {...register("gender")} className="form-control" >
                                <option value="male">male</option> 
                                <option value="female">female</option> 
                                </select>   
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                                {isLoading.status !='pending' ? 
                                                
                                     <button type="submit" className="btn btn-warning w-100" >Add Learners</button>
                                                :
                                    <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}